import { __rest } from "tslib";
import * as React from 'react';
import { DropdownArrowContext } from './dropdownConstants';
import { InternalDropdownItem } from './InternalDropdownItem';
import { Divider, DividerVariant } from '../Divider';
export var DropdownSeparator = function DropdownSeparator(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      ref = _a.ref,
      props = __rest(_a, ["className", "ref"]);

  return React.createElement(DropdownArrowContext.Consumer, null, function (context) {
    return React.createElement(InternalDropdownItem, Object.assign({}, props, {
      context: context,
      component: React.createElement(Divider, {
        component: DividerVariant.div
      }),
      className: className,
      role: "separator"
    }));
  });
};